<mat-radio-group class="d-flex flex-column" [(ngModel)]="valueSet" (ngModelChange)="onChangeValue($event)">
  <ng-container *ngFor="let item of items">
    <mat-radio-button color="primary" class="visit-radio-button" [value]="item.value">
      <span class="visit-text">{{item.label}}</span>
    </mat-radio-button>
    <ng-container *ngIf="item.isAllowOtherValue && item.value == valueSet">
      <mat-form-field appearance="outline" class="w-100 py-2">
        <input matInput [(ngModel)]="otherValueSet" (ngModelChange)="onChangeOtherValue($event)" [placeholder]="placeholder">
      </mat-form-field>
    </ng-container>

  </ng-container>
</mat-radio-group>
